import React, { Component } from "react";

//// componentes reutilizables
import DataTable from "react-data-table-component";
import AuthService from "../../../services/login/auth.service";
import {mensajeExito} from "../../generico/MensajeSistemaToast";
import RuedaService from "../../../services/rueda/RuedaService";
import { trackPromise } from "react-promise-tracker";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight, faFileContract, faFilePdf} from "@fortawesome/free-solid-svg-icons";

export default class Rueda4 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.newTransfer = this.newTransfer.bind(this);
  }

  getInitialState = () => ({
    datosCuenta: [],
  });

  resetState = () => {
    this.setState(this.getInitialState());
  };
  
  componentDidMount() {
    this.getDatosCuenta();
  }

  descargar = async () => {
    await trackPromise(
      RuedaService.descagarComprobante("Adquisición de Rueda", this.props.nroOperacion, AuthService.getSocio().numeroSocio.trim() +
      " - "+AuthService.getSocio().nombreCompleto, this.props.ctaFullData.ahorro +" - "+this.props.ctaFullData.descripcion,
       "GS",this.props.nroContrato,this.props.grupo.fechaModulo,this.props.grupo.fechaVencimiento,this.props.grupo.importeTotalDebito,this.props.grupo.importeCuota)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }

  descargarContrato = async () => {
    await trackPromise(
      RuedaService.descagarContrato("CONTRATO DE LA RUEDA GIGANTE DE SOLIDARIDAD", this.props.grupo.id,this.props.nroContrato,this.props.cuentaAsignada,this.props.sucursal,
      AuthService.getSocio().nombreCompleto.trim(),
      AuthService.getSocio().numeroSocio.trim(),AuthService.getSocio().numeroCedula.trim(),this.props.pdfContrato)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      },
    ];
  }

  getDatosCuenta() {
    var respuesta = [
      {
        concepto: "Nro. de Contrato:",
        valor: this.props.porSuerte
          ? "Será Autogenerado"
          : this.props.nroContrato,
      },

      {
        concepto: "Fecha del 1° Vencimiento de Cuota:",
        valor: this.props.grupo.fechaModulo,
      },
      {
        concepto: "Fecha de Vencimiento de la Cuenta:",
        valor: this.props.grupo.fechaVencimiento,
      },
      {
        concepto: "Total a Debitar:",
        valor: this.props.grupo.importeTotalDebito,
      },
      { concepto: "Importe Cuota:", valor: this.props.grupo.importeCuota },
    ];

    return respuesta;
  }

  newTransfer() {
    this.props.returnDataPaso4();
    this.firstStep.click();
  }

  render() {
    if(this.props.currentStep===4){
      mensajeExito("Operación Realizada Exitosamente")
    } 
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Plan
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Número de Contrato</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <p className="nro-operacion">
              Número de Operación: {this.props.nroOperacion}                        
            </p>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <h6 className="item-vef" style={{ margin: 0 }}>
              Socio: {AuthService.getSocio().numeroSocio} -{" "}
              {AuthService.getSocio().nombreCompleto}
            </h6>
            <p className="item-vef" style={{ marginBottom: 0 }}>
              Cuenta: {this.props.ctaFullData.ahorro} -{" "}
              {this.props.ctaFullData.descripcion}{" "}
            </p>
            <p className="item-vef">Moneda: {this.props.ctaFullData.moneda} .</p>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <div className="row">
              <div className="table-responsive">
                <DataTable
                  noHeader={true}
                  columns={this.getColumn()}
                  data={this.getDatosCuenta()}
                  dense={true}
                  noDataComponent="No se pudo realizar la compra"
                  responsive={true}
                  noTableHead={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-md-center invoice-info">
          <div className="col-lg-8 col-md-12" style={{padding:"0", marginTop:"2rem"}}>
            <div
              className="card declaracion"
            >
              <p>
                Declaro bajo la fe de Juramento que los fondos de todas las
                operaciones y transacciones que realizo o realizaré con la <strong>UNIVERSITARIA LTDA.</strong> durante mi vinculación comercial
                con la Institución, cualquiera sea su naturaleza, denominación,
                condición o modalidad de las mismas, provienen y/o provendrán de
                fuentes lícitas.
              </p>
            </div>
          </div>
        </div>

        <hr />
        <div className="row">
          <div className="col-md-3 col-12"></div>
          <div className="col-md-3 col-12 btn-consulta">
          <button
            onClick={this.newTransfer}
            type="button"
            className="btn btn-cu-quintary"
          >
          <FontAwesomeIcon icon={faArrowLeft} />  Ir al Inicio
          </button>
          </div>
          <div className="col-md-3 col-12 btn-consulta">
          <button
            className="btn btn-cu-secundary"
            onClick={this.descargarContrato}
          >
          <FontAwesomeIcon icon={faFileContract} />  Descargar Contrato
          </button>
          </div>
          <div className="col-md-3 col-12">
          <button className="btn btn-cu-primary" onClick={this.descargar}><FontAwesomeIcon icon={faFilePdf} /> Descargar Comprobante</button>

          <button
            hidden
            ref={(a) => (this.firstStep = a)}
            onClick={this.props.firstStep}
          ></button>
          </div>
        </div>
        
      </div>
    );
  }
}
